// src/components/Footer.js
import '../styles/Footer.css';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useWallet } from '../components/WalletContext';
import { ThemeContext } from '../components/ThemeContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Footer = () => {
  const { useKdaFee, toggleKdaFee, kdaOptions, selectedKda, setSelectedKda } = useWallet();
  const { isDarkMode, toggleTheme } = useContext(ThemeContext);

  const socialLinks = [
    { icon: 'twitter', url: 'https://x.com/FOMO_Apes', label: 'Twitter' },
    { icon: 'telegram', url: 'https://t.me/fomoape_nft', label: 'Telegram' },
  ];

  const quickLinks = [
    { label: 'About', path: '/about' },
    { label: 'Support', path: '/support' },
    { label: 'Terms', path: '/terms' },
    { label: 'Privacy', path: '/privacy' },
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Top Section */}
        <div className="footer-top">
          {/* Brand & Description */}
          <div className="footer-brand">
            <div className="footer-logo">
              <img src="/logoicon2.png" alt="Rare Canvas" className="footer-logo-icon" />
              <span className="footer-brand-name">
                <span className="rare">Rare</span>
                <span className="canvas">Canvas</span>
              </span>
            </div>
            <p className="footer-description">
              The ultimate NFT marketplace on Klever Chain. Trade, collect, and create 
              extraordinary digital assets with confidence.
            </p>
            <div className="footer-social">
              {socialLinks.map((social) => (
                <a
                  key={social.icon}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label={social.label}
                  title={social.label}
                >
                  <FontAwesomeIcon icon={['fab', social.icon]} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h4 className="footer-links-title">Quick Links</h4>
            <nav className="footer-nav">
              {quickLinks.map((link) => (
                <Link key={link.path} to={link.path} className="footer-link">
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Settings & Controls */}
          <div className="footer-settings">
            <h4 className="footer-settings-title">Settings</h4>
            
            {/* Theme Toggle */}
            <div className="setting-group">
              <label className="setting-label">
                <span className="setting-name">
                  <FontAwesomeIcon icon={isDarkMode ? 'moon' : 'sun'} className="setting-icon" />
                  Theme
                </span>
                <label className="theme-switch">
                  <input 
                    type="checkbox" 
                    checked={!isDarkMode} 
                    onChange={toggleTheme}
                    aria-label="Toggle theme"
                  />
                  <span className="slider">
                    <span className="slider-track"></span>
                    <span className="slider-thumb"></span>
                  </span>
                </label>
              </label>
            </div>

            {/* KDA Fee Toggle */}
            <div className="setting-group">
              <label className="setting-label">
                <span className="setting-name">
                  <FontAwesomeIcon icon="coins" className="setting-icon" />
                  Pay Fees with KDA
                </span>
                <label className="toggle-switch">
                  <input 
                    type="checkbox" 
                    checked={useKdaFee} 
                    onChange={toggleKdaFee}
                    aria-label="Toggle KDA fee payment"
                  />
                  <span className="toggle-slider"></span>
                </label>
              </label>
            </div>

            {/* KDA Select */}
            {useKdaFee && (
              <div className="setting-group kda-select-group">
                <label className="kda-label">
                  <FontAwesomeIcon icon="wallet" className="kda-icon" />
                  Select KDA Asset
                </label>
                <select 
                  value={selectedKda} 
                  onChange={(e) => setSelectedKda(e.target.value)} 
                  className="kda-select"
                >
                  <option value="">Choose KDA...</option>
                  {kdaOptions.map(kda => (
                    <option key={kda} value={kda}>{kda}</option>
                  ))}
                </select>
              </div>
            )}
          </div>
        </div>

        {/* Bottom Section */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">
              © 2023-2026 Rare Canvas by FOMO Apes. All rights reserved.
            </p>
            <div className="footer-badges">
              <span className="version-badge">
                <FontAwesomeIcon icon="code-branch" />
                v2.0.2
              </span>
              <span className="chain-badge">
                <span className="chain-dot"></span>
                Klever Chain
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;